module.exports = __webpack_public_path__ + "static/media/C46.PNG.815fc1a7.png";